/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosím přiložte fotografii produktu a fotografii štítku produktu se čitelným odkazem`
};

const da_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Vedhæft venligst et billede af produktet og et billede af etiketten med læsbar reference`
};

const de_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte fügen Sie ein Foto des Produkts und des Etiketts mit lesbarer Referenz als Anhang bei`
};

const en_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Please attach a photo of the product and a photo of the product label with a readable reference`
};

const es_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, adjunta una foto del producto y una foto de la etiqueta del producto con la referencia legible`
};

const fr_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Merci de nous fournir en pièce jointe une photo du produit et photo de l'étiquette produit avec référence lisible`
};

const hu_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Kérjük, mellékeld a termék fotóját és a termékcímke fotóját olvasható hivatkozással`
};

const it_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Fornisci in allegato una foto del prodotto e dell'etichetta con riferimento leggibile`
};

const nl_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Voeg een foto van het product en het etiket met leesbare referentie toe`
};

const pl_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosimy o załączenie zdjęcia produktu i etykiety z widocznym numerem referencyjnym`
};

const pt_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, anexe uma foto do produto e da etiqueta com referência legível`
};

const sv_contact_helper_messages_confirmation_wrong_product = /** @type {(inputs: {}) => string} */ () => {
	return `Vänligen bifoga en bild på produkten och etiketten med synlig referens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_helper_messages_confirmation_wrong_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_helper_messages_confirmation_wrong_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_helper_messages_confirmation_wrong_product", locale)
	if (locale === "cs") return cs_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "da") return da_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "de") return de_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "en") return en_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "es") return es_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "fr") return fr_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "hu") return hu_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "it") return it_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "nl") return nl_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "pl") return pl_contact_helper_messages_confirmation_wrong_product(inputs)
	if (locale === "pt") return pt_contact_helper_messages_confirmation_wrong_product(inputs)
	return sv_contact_helper_messages_confirmation_wrong_product(inputs)
};
export { contact_helper_messages_confirmation_wrong_product as "contact.helper_messages.confirmation.wrong_product" }